import { render, staticRenderFns } from "./AssetLabPicker.vue?vue&type=template&id=120c5fb8&"
import script from "./AssetLabPicker.vue?vue&type=script&lang=js&"
export * from "./AssetLabPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports